module.exports = __webpack_public_path__ + "qna-bg.png?35d694cc7f3201fe0ec19613ad5536e1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qna-bg.png
// module id = 185
// module chunks = 0